import ReactQuill from 'react-quill';
import { useMemo, useRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import './RichTextInput.css';

export const RichTextInput = (props: any) => {
  const ref = useRef<ReactQuill>(null);

  const insertToEditor = (url: string) => {
    if (ref.current === null) return;
    if (ref.current.editor === undefined) return;

    const range = ref.current.editor.getSelection();
    if (range === null) return;

    ref.current.editor.insertEmbed(range.index, 'image', url);
  };

  const uploadImage = async (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    const res = await fetch(`${import.meta.env.VITE_API_URL}/admin/static_images`, {
      method: 'POST',
      body: formData,
    });
    const { id } = await res.json();

    insertToEditor(`${import.meta.env.VITE_API_URL}/api/v1/static_images/${id}`);
  };

  const selectImage = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.click();

    input.onchange = () => {
      const file = input.files![0];

      // file type is only image.
      if (/^image\//.test(file.type)) {
        void uploadImage(file);
      } else {
        alert('画像のみアップロードできます。');
      }
    };
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        handlers: {
          image: selectImage,
        },
        container: [[{ header: [1, 2, 3, 4, false] }], ['image']],
      },
    }),
    [],
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'imageBlot',
  ];

  return (
    <ReactQuill
      ref={ref}
      theme="snow"
      modules={modules}
      formats={formats}
      onChange={props.onChange}
      value={props.value}
      id={props.id}
    />
  );
};
